import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Alert, AlertStatus, HistoryEntry, LocationDeviceStatus } from '../models';

@Injectable({ providedIn: 'root' })
export class SignalCenterService {
  private apiBase = `${environment.apiBase}/v1.0/alerts`;

  constructor(private http: HttpClient) {}

  getAlerts(): Observable<Alert[]> {
    return this.http.get<Alert[]>(this.apiBase);
  }

  updateAlertStatus(id: string, status: AlertStatus, note: string): Observable<Alert> {
    return this.http.put<Alert>(`${this.apiBase}/${id}/status`, { status, note });
  }

  assignAlert(id: string, assignee: string): Observable<Alert> {
    return this.http.put<Alert>(`${this.apiBase}/${id}/assign`, { assignee });
  }

  getHistory(): Observable<HistoryEntry[]> {
    return this.http.get<HistoryEntry[]>(`${this.apiBase}/history`);
  }

  getLocationOverview(locationId: number): Observable<{ history: HistoryEntry[]; devices: LocationDeviceStatus }> {
    return this.http.get<{ history: HistoryEntry[]; devices: LocationDeviceStatus }>(`${this.apiBase}/locations/${locationId}/overview`);
  }

  getAlertCount(locationId: number): Observable<number> {
    return this.http.get<number>(`${this.apiBase}/locations/${locationId}/alert-count`);
  }

  getPosSyncWarning(locationId: number): Observable<HistoryEntry | null> {
    return this.http.get<HistoryEntry | null>(`${this.apiBase}/locations/${locationId}/pos-sync-warning`);
  }
}
